import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { IMAGES } from "../data/content";

export default function About() {
  return (
    <div data-testid="about-page" className="bg-bone">
      <section className="pt-28 lg:pt-36 pb-16 bg-charcoal">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow text-gold mb-3">Our Story</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-semibold text-white text-balance max-w-3xl">
            Great food isn't the mission — it's the reality.
          </h1>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-2 items-center">
            <div className="relative">
              <div className="aspect-[4/5] overflow-hidden rounded-3xl">
                <img src={IMAGES.chefJuliet} alt="Juliet, founder of Taste of Platinum" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-5 -right-4 sm:right-6 rounded-2xl bg-gold px-6 py-4 shadow-xl">
                <div className="font-serif text-2xl font-semibold text-charcoal">Meet Juliet</div>
                <div className="text-xs text-charcoal/70 tracking-wide">Founder & Chef</div>
              </div>
            </div>
            <div>
              <SectionHeading eyebrow="Meet Juliet" title="A Lifelong Passion for Flavor" />
              <div className="mt-6 space-y-5 text-slate-700 leading-relaxed">
                <p>Juliet's passion for food began during childhood and has remained at the heart of everything she creates today.</p>
                <p>Whether cooking for friends, family, coworkers, formal events, or casual gatherings, the passion has always remained the same: creating great food that people remember.</p>
                <p>At Taste of Platinum, great food isn't simply the mission — it's the tangible reality. Every meal is prepared with passion, flavor, and a commitment to creating an experience worth remembering.</p>
              </div>
              <div className="mt-8 rounded-2xl border border-gold/30 bg-white p-6">
                <Quote className="w-6 h-6 text-gold" />
                <p className="mt-2 font-serif text-2xl text-charcoal">Come Taste the Islands at Taste of Platinum.</p>
              </div>
              <Link to="/contact" data-testid="about-cta"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-charcoal px-7 py-4 font-semibold text-white hover:bg-charcoal-void transition-colors">
                Plan Your Event <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
